import curry from 'lodash/curry';
import mapValues from 'lodash/mapValues';

import IThemeInterface from '../../Theme/common';

import { VALID_MEDIA_MAP } from './common';
import { makeMediaStyles } from './makeMediaStyles';
import { normalizeColor } from './normalizeColor';

export type VALID_COLOR_DATA = VALID_MEDIA_MAP | string;
export type VALID_COLOR_MEDIA_TYPES =
  | 'color'
  | 'stroke'
  | 'fill'
  | 'background-color'
  | '-webkit-text-fill-color';

export const normalizeColorMedia = curry((
  theme: IThemeInterface, kind: VALID_COLOR_MEDIA_TYPES, color: VALID_COLOR_DATA
) => {
  const normalizedObj = typeof color === 'string' ?
    normalizeColor(theme, color) :
    mapValues(color, (val: string) => (normalizeColor(theme, val)));

  return makeMediaStyles(kind, normalizedObj);
});
